import React from 'react';
import clsx from 'clsx';
import { ShieldCheck, BookOpen, MinusCircle } from 'lucide-react';
import { TAG_LABELS } from '../lib/parseDrishtiResponse';

/**
 * The trust tag is the single most important piece of UI in Drishti —
 * it tells the COO what KIND of answer they're looking at. Must be
 * immediately visible on every assistant response.
 */

const TAG_STYLES = {
  from_audit_data: {
    icon: ShieldCheck,
    bg: 'bg-sky-50',
    text: 'text-sky-700',
    ring: 'ring-sky-200',
  },
  from_analysis: {
    icon: BookOpen,
    bg: 'bg-violet-50',
    text: 'text-violet-700',
    ring: 'ring-violet-200',
  },
  no_answer: {
    icon: MinusCircle,
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    ring: 'ring-slate-200',
  },
};

export default function TrustTag({ tag }) {
  if (!tag || !TAG_STYLES[tag]) return null;

  const { icon: Icon, bg, text, ring } = TAG_STYLES[tag];
  const label = TAG_LABELS[tag];

  return (
    <span
      data-drishti="trust-tag"
      data-tag={tag}
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1',
        bg,
        text,
        ring,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {label}
    </span>
  );
}
